import type { TriggerFieldInputProps } from '../../types/types';
import ExoField from './ExoField';
import InputWithTokens from './InputWithTokens';

const StringField = ({
    option,
    outputs,
    value,
    onChange,
    type,
    showValidation = false,
    validationMessage = null,
}: TriggerFieldInputProps) => {
    return option.allowOutputs ? (
        <InputWithTokens
            id={option.id}
            onChange={(text) => onChange(option.id, text)}
            tokens={outputs || []}
            value={(value as string) ?? ''}
            isSingleLine
        />
    ) : (
        <ExoField
            option={option}
            value={value}
            onChange={onChange}
            type={type}
            showValidation={showValidation}
            validationMessage={validationMessage}
        />
    );
};

export default StringField;
